// extracted by mini-css-extract-plugin
export default {"resumeKey":"Zreport_resumeKey__Wi51q","resumeIcon":"Zreport_resumeIcon__f9-rF","resumeValue":"Zreport_resumeValue__FhkNz","row":"Zreport_row__1XaHj","card":"Zreport_card__HVfTQ"};